export const shotColors = {
    firstShot: '#EEBE1B',
    secondShot: '#C8B7C7',
    approachShot: '#E1793D',
    otherShot: '#025068'
};

export const autoShotTypes = {
    used: 'USED',
    outOfBounds: 'OUT_OF_BOUNDS'
};

export const shotTypes = {
    unknown: 'UNKNOWN',
    tee: 'TEE',
    approach: 'APPROACH',
    chip: 'CHIP',
    putt: 'PUTT',
    recovery: 'RECOVERY',
    layup: 'LAYUP'
};

export const resizePoint = (point, mapSize, tileSize) => {
    // resize a point from tileSize to mapSize
    // point in form {x:500, y:500}
    // mapSize in form {x:500, y:500}
    // tilSize is int i.e. 730
    if (!point) {
        throw new Error('Point is required to resizePoint');
    }
    if (!tileSize) {
        throw new Error('TileSize is required to resizePoint');
    }
    let pointToReturn = JSON.parse(JSON.stringify(point)); //structuredClone(point);
    if (mapSize) {
        pointToReturn.x = (point.x * mapSize.x) / tileSize;
        pointToReturn.y = (point.y * mapSize.y) / tileSize;
    }
    return pointToReturn;
};

export const unResizePoint = (point, mapSize, tileSize) => {
    // take a resized point, and return one sized for the API
    if (!point) {
        throw new Error('Point is required to unResizePoint');
    }
    if (!tileSize) {
        throw new Error('TileSize is required to unResizePoint');
    }
    if (!mapSize) {
        throw new Error('MapSize is required to unResizePoint');
    }
    var pointToReturn = {};
    pointToReturn.x = Math.round((point.x * tileSize) / mapSize.x);
    pointToReturn.y = Math.round((point.y * tileSize) / mapSize.y);
    return pointToReturn;
};

export const markerDirection = (resizedPoint, mapSize) => {
    const markerSize = 90; // marker extends around this amount
    if (resizedPoint.x < mapSize.x - markerSize) {
        return 'right';
    }
    return 'left';
};

export const getShotColor = (par, shotOrder, numShots) => {
    // approachShot === approach shot in regulation

    switch (par) {
        case 3:
            switch (shotOrder) {
                case 1:
                    return shotColors.firstShot;
                default:
                    return shotColors.otherShot;
            }
        case 4:
            switch (shotOrder) {
                case 1:
                    return shotColors.firstShot;
                case 2:
                    return numShots < 3 ? shotColors.approachShot : shotColors.otherShot;
                default:
                    return shotColors.otherShot;
            }
        default:
            switch (shotOrder) {
                case 1:
                    return shotColors.firstShot;
                case 2:
                    return shotColors.secondShot;
                case 3:
                    return numShots < 4 ? shotColors.approachShot : shotColors.otherShot;
                default:
                    return shotColors.otherShot;
            }
    }
};

export const formatShotsForSave = (shots, pinPosition) => {
    return shots.map((shot, index) => {
        return {
            ...shot,
            shotOrder: index + 1,
            endLoc: shots[index + 1]?.startLoc || pinPosition,
            id: shot.id < 0 ? undefined : shot.id
        };
    });
};

export const scorecardShotMapUrl = (displayName, scorecardId, holeNumber) => {
    return `/golf-shots/${displayName}/scorecard/${scorecardId}/hole/${holeNumber}`;
};

export const golfCourseShotMapUrl = (displayName, courseId, holeNumber) => {
    return `/golf-shots/${displayName}/golf-course/${courseId}/hole/${holeNumber}`;
};

export default class GolfShotMapUtil {
    static resizePoint = resizePoint;

    static markerDirection = markerDirection;
}
